<div class="variants-selector__container" [ngClass]="{
'row-with-sizes': variantsSelectorHeightconfig?.hasSizes && !variantsSelectorHeightconfig?.hasColors,
'row-with-colors': variantsSelectorHeightconfig?.hasColors && !variantsSelectorHeightconfig?.hasSizes,
'row-full': variantsSelectorHeightconfig?.hasColors && variantsSelectorHeightconfig?.hasSizes,
'only-color': colors?.totalCount && !hasSizes,
'only-sizes': !colors?.totalCount && hasSizes,
'carousel-with-variants': (variantsSelectorHeightconfig?.hasColors || variantsSelectorHeightconfig?.hasSizes) && carouselProductCard
}" [mmTestTarget]="'product-cards-variants'">
  <ng-container *ngIf="isMobile && ((colors && colors?.totalCount) || hasSizes); else bullets">
    <a class="variants__link variants__text" (click)="onMoreSizesAvailableLinkClick($event)">
      <ng-container *ngIf="colors && hasSizes">
        {{ 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-PLUS-COLORS-SIZES' | translate: {number: variants?.totalCount} }}
      </ng-container>
      <ng-container *ngIf="(colors && colors?.totalCount) && !hasSizes">
        {{ (colors?.totalCount > 1
        ? 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-PLUS-COLORS-PLURAL'
        : 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-PLUS-COLORS') | translate: {number: colors?.totalCount}
        }}
      </ng-container>
      <ng-container *ngIf="!colors && hasSizes">
        {{  (variants?.totalCount > 1
        ? 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-PLUS-SIZES-PLURAL'
        : 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-PLUS-SIZES')
        | translate: {number: variants?.totalCount} }}
      </ng-container>
    </a>
  </ng-container>
  <ng-template #bullets>
    <p *ngIf="hasSizes" class="variants__text more-sizes__text variants__link"
       [mmTestTarget]="'product-cards-more-available-sizes'"
       (click)="onMoreSizesAvailableLinkClick($event)">
      <ng-container>
        {{ 'CATALOG.CATALOG_PAGE.PRODUCT-CARD.VARIANTS-AVAILABLE-SIZES' | translate }}
      </ng-container>
    </p>
    <div *ngIf="colors?.totalCount" class="color__bullets-container">
      <a class="color__bullet base__bullet" [mmTestTarget]="'product-cards-more-base-bullet'" [href]="baseProductLink"
         (click)="onBaseProductBulletClick($event)">
        <span class="hidden">
          {{colors.value}}
        </span>
        <img [title]="colors.value" [srcset]="getSrcSet(baseProductImage)" [alt]="colors?.value"/>
      </a>
      <a *ngFor="let color of colors?.items | slice: 0: 3" [href]="getPdpLink(color?.id)"
         [mmTestTarget]="'product-cards-more-color-bullet'"
         class="color__bullet"
         (click)="onBulletClick($event, color?.id)">
        <span class="hidden">
          {{color?.value}}
        </span>
        <img [title]="color?.value" [srcset]="getSrcSet(color?.image)" [alt]="color?.value"/>
      </a>
      <a *ngIf="colors?.totalCount >= 3 && !!(colors?.totalCount - 3)" [href]="baseProductLink"
         [mmTestTarget]="'product-cards-more-color-more'"
         class="addition__variants-bullets variants__text variants__link">
        + {{ colors?.totalCount - 3}}
      </a>
    </div>
  </ng-template>
</div>
